export default "__VITE_ASSET__h9k$Ds5I__"